import type { PropertyPaneConfig } from "legacy/constants/PropertyControlConstants";

import type { ItemWithPropertiesType } from "./ItemKindConstants";

const propertyPaneConfigsRegistry = new Map<
  ItemWithPropertiesType,
  readonly PropertyPaneConfig[]
>();

export function getItemPropertyPaneConfig(
  type: ItemWithPropertiesType,
): readonly PropertyPaneConfig[] {
  return propertyPaneConfigsRegistry.get(type) ?? [];
}
